module.exports = __webpack_public_path__ + "static/ekaete-842fcc7167f5d4887af46b8f75bdc87f.png";